import React, { useState,useEffect} from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import OTPInput, { ResendOTP } from "otp-input-react";
import { json, useNavigate } from 'react-router-dom';
import Web3 from "web3";
import Api from '../../utils/Api';
import { toast } from 'react-toastify';
import contractABI from '../../utils/contractABI';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const ResetPassword = () => {
  let Navigater=  useNavigate()
  const [OTP, setOTP] = useState("");
  const [web3, setWeb3] = useState(null);
  const [contracts, setContract] = useState(null);
  const [isconnected, setisconnected] = useState(false);
  const [signer, setSigner] = useState(null);
  const [name,setName]=useState("")
const [txhash,setTxHash]=useState({})
    const[Validation,setValidation]=useState({
      name:"",
      email:"",
      password:"",
      ConfirmPassword:""
    })
  const [email,setemail]=useState("")
  const [password,setpassword]=useState("")
  const [ConfirmPassword,setConfirmPassword]=useState("")



  // const navigate = useNavigate();
  const Navigate= useNavigate()
  const inputStyle = {
    width: '2rem', // Adjust the width as needed
    height: '2rem', // Adjust the height as needed
    fontSize: '1.5rem', // Adjust the font size as needed
    border: '1px solid #ccc', // Add a border for the input fields
    borderRadius: '4px', // Add rounded corners
    margin: '0.25rem', // Add some margin between input fields
    textAlign: 'center', // Center the text within the input field
  };

  const registerProvider = async () => {
// console.log("Name is Rafay",contracts)
    try {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      console.log(account);
      const result = await contracts.methods
        .registerProvider(name)
        .send({ from: account });
      setTxHash(result.transactionHash);
      if (result?.transactionHash) {
        console.log(result)
        // setShowModal(true);
        setTimeout(() => {
          // setShowModal(false);
          // Navigate("/main");
          
          alert(`${result} jasgfjkgasjgfjasgfjg`)
        }, 5000);
      } else {
        alert("Not transaction DOne Successfully")
        // setShowModal(false);
      }
    } catch (error) {
      console.error(error);
    }

    // setLoading(false);
  };
const onSumit=async()=>{
  try {
    let error={}
     let  otpemail=localStorage.getItem("otpemail")
    console.log("==========",email)
    console.log("==========",password)
    if(!password){
      error.password="Password is required"

    }
    if(!ConfirmPassword){
      error.ConfirmPassword="Confirm Password is required"

    }else if(password!==ConfirmPassword){
      error.ConfirmPassword="Password and Confirm Password do not match. Please ensure that both fields contain the same information for confirmation."
    
    }
    if(Object.keys(error).length > 0){
      setValidation(error)
       return
    }
const loginData=await Api.Api.post("/user/updatePassword",{
     "email": otpemail,
     "newPassword": password
 })
 toast.success(loginData.data.message)
 Navigater("/auth/Login")
  } catch (error) {
    if(error.response){
 toast.error(error.response.data.message)
    }else{

    }
    console.log("🚀 ~ file: login.js:555 ~ onSumit ~ error:", error)
    
  }

}
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setshowConfirmPassword] = useState(false);

  return (
    <div style={{ display:"flex",justifyContent:"center",marginTop:"10%", width: "100%", backgroundColor: "#F3F4F8" }}>
           
           <div     style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width:"50%"
        }}>      <span className='Loginheading'>
                    Reset Password  
            </span>
            <div className='LoginScreen'>
               
                 <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"90%", fontFamily: 'Manrope, sans-serif'}}>Password</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField  onChange={(e)=>{
                         setpassword(e.target.value)
                        }} 
                        helperText={Validation.password}
                        error={Validation.password}
                        type={showPassword ? 'text' : 'password'}
                         value={password}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                edge="end"
                                onClick={() => setShowPassword((prev) => !prev)}
                                aria-label="toggle password visibility"
                              >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }} 
                        style={{width:"90%"}} id="outlined-basic" label="Enter your Password" variant="outlined" />
                            {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
                        </div>
                 </div>
                 <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"90%", fontFamily: 'Manrope, sans-serif'}}>Confirm Password</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField value={ConfirmPassword}
                         helperText={Validation.ConfirmPassword}
                         error={Validation.ConfirmPassword}
                        onChange={(e)=>{
                         setConfirmPassword(e.target.value)
                        }} style={{width:"90%"}}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                edge="end"
                                onClick={() => setshowConfirmPassword((prev) => !prev)}
                                aria-label="toggle password visibility"
                              >
                                {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        type={showConfirmPassword ? 'text' : 'password'}
                        id="outlined-basic" label="Enter Your Password" variant="outlined" />
                            {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
                        </div>
                 </div>
                            
                 <div style={{display:"flex",width:"90%",alignSelf:"center",justifyContent:"flex-end",paddingBottom:20}}>
                     <div style={{display:"flex",justifyContent:"space-evenly"}}>
                     <Button onClick={
                      onSumit
                      // Navigate("/admin-panel/verifiedProvider")
                     } variant="contained">Reset</Button>    
                 </div>
                 </div>

            </div>
      </div>    
    </div>
  )
}

export default ResetPassword